import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {
  ROUTE_EVENT_SIGNER,
} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EventSigner = lazy(() =>
  import('../../../screens/EventSigner')
    .then(module => ({default: module.EventSigner})));

const EventSignerNavigation = [
  {
    path: ROUTE_EVENT_SIGNER,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EventSigner />
      </Suspense>
    ),
  },
];

export default EventSignerNavigation;
